{
  "0464d777d1568a1c": "¿Eliminar mensaje?",
  "07a2d579c3f0d325": "Destacado",
  "0a1f2fbcba7a4924": "Mensaje enviado",
  "0d60084f056eb4cf": "No hay conversaciones aún",
  "0d79ff168b4abad5": "· editado",
  "0ec2ae49e4414937": "¿Fue {{workerName}} una ausencia?",
  "11dab6274664c362": "Responder al mensaje",
  "11feeff6baecd5a9": "No enviar",
  "12d82ae5928141ae": "Selecciona una conversación",
  "14d3e2bd48ff4eb2": "Más opciones de chat",
  "14e05c7949dda7ca": "Estas respuestas se compartirán con el profesional en el chat.",
  "155f816c0407310c": "Enviar",
  "15d5681537d5b70c": "Esta acción está reservada para profesionales con notas de visita lentas o ausentes. El bloqueo hará que:",
  "15db6cf63b74d63f": "Este profesional no puede ser invitado a turnos en este lugar de trabajo.",
  "173874fc674b3464": "No se puede asignar a nuevos casos",
  "17a9724ab58b6c42": "Tipo de archivo no compatible. Por favor, carga imágenes, PDFs o documentos de Word.",
  "19766ed6ccb2f4a3": "Cancelar",
  "19c73a5cdf346d96": "Profesional",
  "1aa4263bbe43cfdd": "Filtros de canal",
  "1b9e1aa135771a2f": "Cerrar vista previa de imagen",
  "1b9f384c1436f607": "No leído",
  "1c7af185ab9ab67c": "Anuncio de trabajo: {{placementTitle}}",
  "206eea992f2daf12": "Ver calendario",
  "2355f73150190fc7": "Cancelar respuesta",
  "2396999ffc3ba483": "Este mensaje será eliminado permanentemente para todos.",
  "2487e3d832ca50b9": "Propusiste un nuevo horario de turno",
  "257c8051763d5f71": "Compartir credenciales",
  "25a54122b93c5f88": "Bloquear cuenta del profesional",
  "274888e3d8ba0795": "Desbloquear Profesional",
  "299aff9380977cc5": "¿Reintentar?",
  "2b19d38ff893ed73": "Mensaje Automatizado",
  "2b3f7fdef47be7d9": "Por favor, usa juicio y profesionalismo.",
  "2c19d584bf8ad518": "Marcar como no leído",
  "2e544a292f6979ed": "Turno",
  "314c0fae93ae57c3": "Ver candidato",
  "31fbef162594de01": "Continuar",
  "37281adc1ef51df7": "Describe por qué debería bloquearse la cuenta de este profesional...",
  "37a407f7f7ca1e14": "Bloquear profesional",
  "3b14c5dc986f2a36": "Cerrar chat",
  "3ed9b6a64daba284": "Entrevista programada",
  "3f3bbdf89cbfb1fe": "Cargando horarios de turnos...",
  "4022255740ab5a30": "Solicitud Recibida",
  "4165e2978c2117ef": "Mensajes de chat",
  "419d2b38764f8681": "Revisa la solicitud de envío a casa",
  "41bedd1a62cf3920": "No se pudieron cargar los detalles del turno. Aún puedes enviar el rechazo sin una acción de seguimiento.",
  "42b2a2a0d876aaf8": "Entrevista cancelada",
  "436f860b57898463": "Por favor, completa la razón para la aprobación.",
  "44b23f3add41fbac": "Profesional destacado",
  "464c4ffd019e1e96": "Editar",
  "4758b5bc7d94c1bb": "¿Estás seguro de que deseas desbloquear a este profesional?",
  "4938e979a0d0a156": "Sí, {{workerName}} nunca se presentó a trabajar el turno",
  "497b1882c39ac540": "Cargando detalles del turno...",
  "4ac709aa58bcfe5d": "Desbloquear",
  "4e414af41b7d4876": "Contratando",
  "4e832591dc95eda7": "¿Salió {{workerName}} del turno temprano?",
  "516efaba309fba5d": "Mensaje cancelado",
  "5203691edc6eac2a": "Por favor, proporciona contexto para tu razón de aprobación",
  "5268ce545cfd1bc5": "Falló al bloquear a este profesional. Por favor, intenta de nuevo.",
  "538b6cc4892537c8": "Describe qué necesita suceder antes de que este profesional pueda ser desbloqueado...",
  "554e7df8055a5b26": "Solo los usuarios de la empresa pueden enviar mensajes",
  "588032878324b5e6": "Enviar ahora",
  "5ce4aeba4357203a": "Error al eliminar el mensaje",
  "5d8f22798b0e32ef": "Falló al reportar la ausencia. Por favor, intenta de nuevo.",
  "5e31e8926ceba729": "Opciones de mensaje",
  "61006b850c2d1765": "Sí, el trabajador fue enviado a casa.",
  "6103ae51803696cf": "Invitación a entrevista programada pendiente",
  "653ecb88c925d69a": "Invitación a entrevista cancelada",
  "65e3db405524457a": "Esto durará {{days}} días. Ingresa los detalles del bloqueo en la siguiente página.",
  "66aff25b2a4034ab": "Respondiendo a {{senderName}}",
  "66b8e077d85fe969": "Error al enviar el mensaje",
  "6973cb606bc78799": "¡Gracias por tu respuesta!",
  "6a63d328d7b3d4e8": "Invitar a turno",
  "6a94bfa8b699d2e5": "El bloqueo expirará automáticamente después de {{days}} días.",
  "6c3fe8584f8cba3d": "No, no apruebes",
  "6f0943b503a938bb": "Razón para bloquear",
  "6f4cd7c8dcf57167": "Razón para el rechazo",
  "6fa271453f8ac490": "Cancelar edición",
  "6fb5cd38b73ffa59": "La cuenta de {{workerName}} ha sido desactivada y ya no puede enviar ni recibir mensajes.",
  "7286a96c2bd8186e": "Invitación a entrevista enviada",
  "72ed245d2cf11822": "Razones",
  "7344c04e9e307c21": "Error al reportar que el trabajador se fue temprano. Por favor, inténtalo de nuevo.",
  "73b0c119934508c5": "Mensaje cancelado",
  "73cb145a22b3d8e6": "Cómo desbloquear",
  "73d963fcf950088e": "Hora WPL:",
  "76900f1bfd16c8d4": "Atrás",
  "78f5975a5d705e95": "Nuevo mensaje",
  "7ad7363a5819c924": "Cuenta del Profesional bloqueada",
  "7d99b198ba5bad55": "No se pueden aceptar nuevas visitas de Atención Domiciliaria",
  "7dbfd44a87232deb": "Editando mensaje",
  "7dc2c9b04fedc9a4": "Invitar al Turno",
  "7ea56b231dd1fba8": "Puedes proporcionar contexto para tu razón de aprobación",
  "7f55382219f0202c": "Buscar...",
  "7fd435c1a03f8f28": "El tamaño del archivo debe ser menor a 10MB",
  "846d05b5aec949db": "Agregar a destacados",
  "852df26908c3c970": "La entrevista de {{workerName}} ha sido cancelada por el lugar de trabajo.",
  "87f6dfda0977757d": "Por favor seleccione si desea que publiquemos un turno de reemplazo urgente.",
  "87fbe4fb79b1d700": "Adjuntar archivo",
  "895e24c74a7ddb71": "Error al desbloquear a este profesional. Por favor, inténtalo de nuevo.",
  "89713b9c9c1b8f65": "Aceptar",
  "8a7525b1492fb848": "Notas",
  "8b2bd68e24610c8d": "Este es un mensaje automatizado enviado en nombre de tu instalación",
  "8b4a28105b186b0e": "Invitación a entrevista",
  "8dc90f8c6f07b3a3": "¿Aprobar este turno como enviado a casa?",
  "8ec1b7b0dfed097f": "{{currentLength}}/{{minimumLength}} caracteres como mínimo",
  "905215e97d44789f": "Por favor agregue notas para describir por qué el trabajador no fue enviado a casa.",
  "90821a3431c5603c": "¿Aceptas esta solicitud de hogar enviada?",
  "9301b7e607985030": "Tu mensaje fue cancelado con éxito.",
  "93063f0beabb3a5d": "Evitar que acepten nuevas visitas",
  "93a26b1eaff99b3a": "Enviar mensaje",
  "93b9bd5f34693a9f": "Turno PM",
  "93c948f6c294adc0": "Error al subir el archivo",
  "942087cc2d41e013": "Reintentar",
  "94518be867eb2f8a": "Expirando en {{displayDuration}}",
  "97cce8bbb9df463f": "Has enviado varias invitaciones de turno",
  "98dad1bca40bbcf9": "Tu mensaje fue enviado con éxito.",
  "99c40ab405926cb5": "Fecha",
  "9a54e5b2b4151dfa": "Razón de aprobación",
  "9b9a8d05a7ec353b": "Leído",
  "9c4ff530a4b48196": "No hay conversaciones que coincidan con tus filtros",
  "9de4149fb9716cfc": "Descargar archivo",
  "9e91a3e9c73c3a08": "Evitar que sean asignados a nuevos casos",
  "9f411825daab7e3e": "Por favor complete el motivo de rechazo.",
  "9faca3224d9578d1": "Entrevista Sugerida",
  "a06faf2668c28d0b": "No hay mensajes",
  "a1911a805b2e584a": "No, el trabajador no fue enviado a casa",
  "a20d12c5e9c428c3": "Pensando",
  "a2d285b352873457": "Rechazar",
  "a424e33d90931d1e": "Bloqueado",
  "a52ace420f2175d0": "Todo",
  "a5e4ce04a6cd1577": "Sí, aprobar",
  "a67b04cd5c491d4d": "Trabajador",
  "a6a5fc451f8f8e92": "Los profesionales en tu lista de DNR no pueden ser añadidos a tu lista de favoritos.",
  "a7826132abbfe036": "Confirmar No Presentación",
  "a7cf9363556dd4ca": "Turno AM",
  "ae55fc046c4cf3ae": "Error al cargar las conversaciones",
  "b0c1b5c59c40d7e4": "{{workerName}} está actualmente bloqueado de este lugar de trabajo.",
  "b0f496c73d51b975": "Entrevista programada con éxito",
  "b269519c244f2c88": "No hay mensajes todavía. ¡Inicia una conversación con {{workerName}}!",
  "b780d4652d4724a2": "Error al marcar el chat como no leído",
  "ba4a26dec0142695": "Error al rechazar solicitud",
  "bb1b36b33a11ea0f": "La cuenta de este profesional ha sido bloqueada por otro lugar de trabajo. Mientras esté bloqueado, este profesional:",
  "bc1c7de0ef33b464": "Cargar más mensajes",
  "bd8f7395f7c52d38": "Bloquear a este profesional permitirá:",
  "c16bc82bf1f04ede": "Enviado",
  "c1c1009d3f37ec05": "Actualizar",
  "c2a520b84ceea67c": "Flexible",
  "c3812fc4acb861d5": "Eliminar",
  "c71cf96ff4711ee0": "Error al crear el canal de chat",
  "c821e8b037f955b7": "Marcar conversación como no leída",
  "c8df66c5fe3f97d0": "Cerrar diálogo",
  "c97583fe90258cd7": "Error al aprobar solicitud",
  "ccca181757536587": "Conversación",
  "ce071bf9950dfa05": "Error al cargar los mensajes del chat. Por favor intenta de nuevo.",
  "d1bf045bb524dae5": "Ver detalles",
  "d456fc75664472cc": "Volver a conversaciones",
  "d4788f256f730423": "Ver perfil",
  "d9924a3cf77aeffe": "Error al cancelar el mensaje",
  "da8e926af6449411": "Error al editar el mensaje",
  "db44b8db4f05d720": "Bloquear",
  "dc1011d87ddbaa17": "El trabajador me pidió que cancelara",
  "df576ba623e98119": "Sí, {{workerName}} nunca trabajó el turno completo",
  "e0e1ef8d687774e2": "Describa las notas pendientes o vencidas; incluya fechas de visita cuando sea posible.",
  "e2d0a54968ead24e": "Eliminar",
  "e31658dca0dfb098": "Solo bloquee si este profesional tiene notas pendientes o vencidas. El bloqueo dura {{days}} días. Ingrese los detalles en la siguiente página.",
  "e482250d535eb95b": "El agente está escribiendo",
  "e7eab2eac45a75af": "Programar entrevista",
  "e82ce23a48d44e4a": "Tenga en cuenta que esta razón se compartirá con el trabajador.",
  "e9bddf7360b6dc62": "Escribe tu mensaje...",
  "eb109d5d22dd2477": "Invitar como",
  "eb13fd621c1e72ae": "Gestionar trabajos",
  "ec711c8c4d8a69f5": "Invitación a la entrevista cancelada",
  "ed4d44fa08fd38d0": "Reportar Trabajador que Se Fue Temprano",
  "efffe1f9cd058fbe": "Invitación a entrevista programada",
  "f1133f6566cd1093": "Eliminar de destacados",
  "f66617b0bd919384": "Has enviado una invitación para el turno",
  "f6820511a8178983": "Mensaje de chat",
  "f8d5b1186d791b61": "Turno NOC",
  "fafdd9b59e05d383": "Tu mensaje fue cancelado con éxito.",
  "fcb2f91b76efc2d6": "Entrevista Cancelada",
  "fd9b5c64be299307": "Chat no disponible",
  "ffa998e6db888ed3": "Describa qué presentaciones de notas son requeridas antes de que este profesional pueda ser desbloqueado."
}
